import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { useMemo } from 'react';
import { isFunction } from '@elliemae/ds-utilities/utils';
import useDerivedStateFromProp from './useDerivedStateFromProps.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'lodash';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var toggleStateInObject = function toggleStateInObject(obj, key, value) {
  var nextObj = _objectSpread({}, obj);

  if (nextObj[key]) {
    delete nextObj[key];
  } else {
    nextObj[key] = value;
  }

  return nextObj;
};

var noop = function noop() {
  return null;
};

function useExpandState(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$itemKey = _ref.itemKey,
      itemKey = _ref$itemKey === void 0 ? 'id' : _ref$itemKey,
      _ref$expanded = _ref.expanded,
      expandedProp = _ref$expanded === void 0 ? {} : _ref$expanded,
      onExpand = _ref.onExpand,
      _ref$onExpandChange = _ref.onExpandChange,
      onExpandChange = _ref$onExpandChange === void 0 ? noop : _ref$onExpandChange,
      _ref$onExpandAll = _ref.onExpandAll,
      onExpandAll = _ref$onExpandAll === void 0 ? noop : _ref$onExpandAll,
      onToggleExpand = _ref.onToggleExpand,
      onCollapse = _ref.onCollapse;

  var _useDerivedStateFromP = useDerivedStateFromProp(expandedProp),
      _useDerivedStateFromP2 = _slicedToArray(_useDerivedStateFromP, 2),
      expanded = _useDerivedStateFromP2[0],
      setExpanded = _useDerivedStateFromP2[1];

  var isExpandedAll = useMemo(function () {
    return Object.keys(expanded).length === items.length;
  }, [expanded, items]);

  var toggleExpandAll = function toggleExpandAll() {
    var stateData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setExpanded(function () {
      var nextState = {};

      if (!isExpandedAll) {
        items.forEach(function (item) {
          nextState[item[itemKey]] = stateData;
        });
      }

      onExpandChange(nextState);
      onExpandAll(nextState);
      return nextState;
    });
  };

  var expand = function expand(item) {
    var stateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!item) return;

    if (isFunction(onExpand)) {
      onExpand(item);
    }

    setExpanded(function (prevState) {
      var key = item[itemKey];

      var nextState = _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, key, stateData));

      onExpandChange(nextState, item);
      return nextState;
    });
  };

  var toggleExpand = function toggleExpand(item) {
    var stateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (isFunction(onToggleExpand)) {
      onToggleExpand(item);
    }

    setExpanded(function (prevState) {
      var key = item[itemKey];
      var nextState = toggleStateInObject(prevState, key, stateData);
      onExpandChange(nextState, item);
      return nextState;
    });
  };

  var collapse = function collapse(item) {
    if (isFunction(onCollapse)) {
      onCollapse(item);
    }

    setExpanded(function (prevState) {
      var nextState = _objectSpread({}, prevState);

      delete nextState[item[itemKey]];
      onExpandChange(nextState, item);
      return nextState;
    });
  };

  return {
    state: {
      expanded: expanded,
      isExpandedAll: isExpandedAll
    },
    actions: {
      expand: expand,
      toggleExpandAll: toggleExpandAll,
      toggleExpand: toggleExpand,
      collapse: collapse
    },
    setExpanded: setExpanded
  };
}

export default useExpandState;
//# sourceMappingURL=useExpandState.js.map
